import { Piling, Company, Project, User } from 'shared_models';

export interface ApiPaginatedResponse<T> extends ApiResponse<T> {
  nextKey: string;
  previousKey: string;
  totalCount: number;
}

export interface ApiResponse<T> {
  data: T;
  message?: string;
  code: ApiErrorCode;
}

export enum ApiErrorCode {
  Unauthorized = 'Unauthorized',
  Forbidden = 'Forbidden',
  NotFound = 'NotFound',
  BadRequest = 'BadRequest',
  InternalServerError = 'InternalServerError',
  Success = 'Success',
}

/** Backend may return `Success` or `SUCCESS` for successful operations. */
export function isApiSuccessCode(code: string | undefined | null): boolean {
  return code === ApiErrorCode.Success || code === 'SUCCESS';
} 